import React, { useState, useEffect } from 'react';
import Heading from '../../../component/Heading/Heading';
import "../../../styles/pages/customer/stammdaten.scss";
import { Autocomplete, FormControl, FormHelperText, FormLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { MenuProps, StammdatenData } from '../../../content/content';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StammdatenTable from './StammdatenTable.jsx';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/de';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { getCustomerStammdaten } from '../../../services/customer-services/customerStammdatenService';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

function Stammdaten() {
    const { t } = useTranslation();
    const [stammdatenErrors, setStammdatenErrors] = useState({});
    const [stammdaten, setStammdaten] = useState({});
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(0);

    const handleStammdatenChange = (e, newValue) => {
        const { name, value } = e.target || {};

        if (name) {
            setStammdaten((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleBranche = (e, newValue) => {
        setStammdaten((prevState) => ({
            ...prevState,
            ["branche"]: newValue?.value,
        }));
    }

    const handleDateChange = (newValue) => {
        setStammdaten((prevState) => ({
            ...prevState,
            grundungjahr: newValue,
        }));
        
    };

    const getAllCustomerStammdaten = async () => {
        const response = await getCustomerStammdaten({ pageNo, perPage });
        if (response?.isSuccess) {
            if (response.customerStammdaten?.grundungjahr) {
                response.customerStammdaten.grundungjahr = dayjs(response.customerStammdaten.grundungjahr);
            }
            setTotalRecords(response?.totalRecord)
            setStammdaten(response?.customerStammdaten || {});
        }
    };

    useEffect(() => {
        getAllCustomerStammdaten();
    }, [pageNo, perPage]);

    return (
        <div className="stammdatenverwaltung">
            <div>
                <Heading text={t('stammdaten_heading')} />
                <div className="stammdatenverwaltung-border">
                    <h3 className="sub-heading">{t("stammdaten_unternehmensdaten")}</h3>
                    <Grid container columnSpacing={5} rowSpacing={2}>
                        {StammdatenData?.map((item, index) => (
                            <Grid item xs={12} md={6} lg={3} key={index} className="select-label">
                                {item.label === "Branche" && item.type === "select" ?
                                    (
                                        <FormControl fullWidth error={!!stammdatenErrors[item.name]}>
                                            <FormLabel
                                                className="label"
                                                sx={{
                                                    paddingTop: "1.25rem",
                                                    paddingBottom: "10px",
                                                    display: "inline-block",
                                                    color: "#000",
                                                }}
                                            >
                                                {t(item.translationKey)}
                                            </FormLabel>
<Autocomplete
    onChange={handleBranche}
    options={item?.options}
    fullWidth
    getOptionLabel={(option) => t(option.translationKey)}
    popupIcon={<ExpandMoreIcon sx={{ fontSize: "30px", color: "#33333399" }} />}
    value={item?.options.find(opt => opt.value === stammdaten[item?.name]) || null}
    sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            border: "1px solid rgba(227, 227, 227, 0.57)",
            padding: "0px !important"
        },
        "& .MuiAutocomplete-input": {
            padding: "10px !important",
            fontSize: "16px",
            fontFamily: "Poppins"
        }
    }}
    renderInput={(params) => (
        <TextField
            {...params}
            name={item?.name}
            placeholder={t('stammdaten_placeholder_branche')}
        />
    )}
/>
                                            {stammdatenErrors[item.name] && (
                                                <FormHelperText
                                                    sx={{
                                                        color: "#d32f2f",
                                                        margin: "5px 0 0 0 ",
                                                        fontSize: "14px",
                                                        fontFamily: "Poppins"
                                                    }}
                                                >
                                                    {stammdatenErrors[item.name]}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    ) : item.type === "select" ? (
                                        <FormControl fullWidth error={!!stammdatenErrors[item.name]}>
                                            <FormLabel
                                                className="label"
                                                sx={{
                                                    paddingTop: "1.25rem",
                                                    paddingBottom: "10px",
                                                    display: "inline-block",
                                                    color: "#000",
                                                }}
                                            >
                                                {t(item.translationKey)}
                                            </FormLabel>
                                            <Select
                                                className="select-input"
                                                fullWidth
                                                value={stammdaten[item?.name] || ""}
                                                onChange={handleStammdatenChange}
                                                displayEmpty
                                                sx={{
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '10px',
                                                        fontSize: '16px',
                                                    },
                                                }}
                                                inputProps={{
                                                    name: item?.name,
                                                    IconComponent: () => (
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                paddingRight: "10px",
                                                            }}
                                                        >
                                                            <ExpandMoreIcon sx={{ fontSize: "30px", color: "#33333399" }} />
                                                        </span>
                                                    ),
                                                }}
                                                style={{
                                                    padding: "0",
                                                    borderRadius: "10px",
                                                    border: "1px solid #e3e3e391",
                                                }}
                                                disabled={item?.name === "year"}
                                                MenuProps={MenuProps}
                                            >
                                                <MenuItem value="" disabled>
                                                    {t(item.placeholderTranslationKey)}
                                                </MenuItem>
                                                {item?.options?.map((option, i) => (
                                                    <MenuItem key={i} value={option.value} disabled={option.value === "2023"}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {stammdatenErrors[item.name] && (
                                                <FormHelperText
                                                    sx={{
                                                        color: "#d32f2f",
                                                        margin: "5px 0 0 0 ",
                                                        fontSize: "14px",
                                                        fontFamily: "Poppins"
                                                    }}
                                                >
                                                    {stammdatenErrors[item.name]}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    ) : item.type === "date" && (
                                    <FormControl fullWidth error={!!stammdatenErrors["grundungjahr"]}>
                                        <FormLabel
                                            className="label"
                                            sx={{
                                                paddingTop: "1.25rem",
                                                paddingBottom: "10px",
                                                display: "inline-block",
                                                color: "#000",
                                            }}
                                        >
                                            {t(item.translationKey)}
                                        </FormLabel>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                            adapterLocale="de"
                                            localeText={{
                                                field: { datePlaceholder: t(item.placeholderTranslationKey) },
                                            }}
                                        >
                                            <DateField
                                                fullWidth
                                                value={stammdaten?.grundungjahr || null}
                                                name="grundungjahr"
                                                onChange={handleDateChange}
                                                format="DD.MM.YYYY"
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: "10px",
                                                    },
                                                    '& input': {
                                                        padding: "10px", // Matches the Select input padding
                                                        fontSize: "16px",
                                                        fontFamily: "Poppins",
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        color: "#d32f2f",
                                                        margin: "5px 0 0 0 ",
                                                        fontSize: "14px",
                                                        fontFamily: "Poppins"
                                                    }
                                                }}
                                                helperText={stammdatenErrors["grundungjahr"] || ""}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                    <StammdatenTable stammdatenData={stammdaten} setStammdaten={setStammdaten} totalRecords={totalRecords} setPageNo={setPageNo} setPerPage={setPerPage} pageNo={pageNo} perPage={perPage} setStammdatenErrors={setStammdatenErrors} getAllCustomerStammdaten={getAllCustomerStammdaten} />
                </div>
            </div>
        </div>
    );
}

export default Stammdaten;
